import { createContext, useState } from "react";

export const ConfigContext = createContext()

export const ConfigProvider = ({ children }) => {
    const [apiURL] = useState('https://stoneapis.stoneskill.com/');
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [customer_id] = useState(localStorage.getItem("customer_id"));
    const [currency, setCurrency] = useState(localStorage.getItem('currency_label') || "₹")
    const [currencyValue, setCurrencyValue] = useState(localStorage.getItem('currency_value') || "INR");

    const [apiHeaderJson] = useState({ 'Content-Type': "application/json", token: `${token}`, 'customer_id': customer_id, 'customer-id': customer_id, currency: currencyValue })


    const handleUpdateLogin = (data) => {
        setToken(data.token);
        localStorage.setItem('token', data.token);
        localStorage.setItem('customer_id', data.customer_id);
    }

    var vals = {
        apiURL,
        apiHeaderJson,
        handleUpdateLogin,
        setCurrencyValue,
        currencyValue,
        customer_id,
        currency,
        setCurrency
    }

    return (
        <ConfigContext.Provider value={vals}>
            {children}
        </ConfigContext.Provider>
    )
}